import { toast } from "../../../../core/helpers/message-helper";
import { Row, Col, Card, CardBody, Container } from "reactstrap";
import { useEffect, useState } from "react";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { selectAreasPorSede } from "../../../../core/services/areas-service";
import { useNavigate, useOutletContext } from "react-router-dom";

const AreasSolicitudes = () => {
    const [areas, setAreas] = useState([]);
    const navigate = useNavigate();
    const { sede, setArea } = useOutletContext();

    useEffect(async () => {
        if (sede == null) {
            navigate("/solicitudes/ciudades");
        }
        const resp = await selectAreasPorSede(sede.id);
        if (!resp.status) return toast.error(resp.message);
        setAreas(resp.data);
    }, []);

    function onClickArea(area) {
        setArea(area);
        navigate("/solicitudes/tipos/");
    }

    return (
        <ContentWrapper>
            <div className="d-sm-flex align-items-center justify-content-center mb-4">
                <div className="h3 mb-0 text-purple-mac">
                    <i className="fas fa-city"></i> Áreas de Soporte
                </div>
            </div>
            <Row>
                {areas.map(function (area) {
                    const style = {
                        cursor: "pointer",
                    };
                    return (
                        <Col md="4" key={area.id}>
                            <Container
                                className="row justify-content-center align-items-center"
                                width="80"
                            >
                                <Card
                                    style={style}
                                    className="border-left-primary shadow h-100 hvr-grow"
                                    onClick={function () {
                                        onClickArea(area);
                                    }}
                                >
                                    <CardBody>
                                        <div className="row">
                                            <div className="col-8">
                                                <p className="h4 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                                    {area.nombre}
                                                </p>
                                                <p className="h5 font-weight-bold text-secondary text-uppercase mb-2 text-left">
                                                    {area.descripcion}
                                                </p>
                                            </div>
                                            <div className="col-4">
                                                <img
                                                    className="rounded-circle"
                                                    width="80"
                                                    height="80"
                                                    src="img/logo_csr_big.png"
                                                />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Container>
                        </Col>
                    );
                })}
            </Row>
        </ContentWrapper>
    );
};

export default AreasSolicitudes;
